import { makeFormStateWithModel } from 'formtastisch'
import { type IntlShape } from 'react-intl'

import { type TENANT } from '../tenant'

import { makeMarketplacePartnerRegisterPageFormValidations } from './marketplacePartnerRegisterPageMakeFormValidations'

export const MarketplacePartnerRegisterPageCompanyType = {
  MANUFACTURER: 'MANUFACTURER',
  RETAILER: 'RETAILER',
} as const

export type MarketplacePartnerRegisterPageCompanyType =
  (typeof MarketplacePartnerRegisterPageCompanyType)[keyof typeof MarketplacePartnerRegisterPageCompanyType]

export const BrandsProviderType = {
  DROPDOWN: 'dropdown',
  LIST: 'list',
} as const

export type BrandsProviderType =
  (typeof BrandsProviderType)[keyof typeof BrandsProviderType]

export type MarketplacePartnerRegisterPageFormModel = {
  accountType: string
  additionalAddress?: string
  annualRevenue: string
  brands: string[]
  brandsDropDown: string[]
  brandsProviderType: BrandsProviderType
  brandsTextArea: string
  categories: string[]
  city: string
  companyType: MarketplacePartnerRegisterPageCompanyType[]
  country: string
  countryCode: string
  customerServiceInRespectiveLanguage: boolean
  description: string
  email: string
  estimatedRevenue: number
  fcSolution: string
  firstName: string
  interestedInRetailMedia: boolean
  keyBrand: string
  lastName: string
  marketReadiness: string
  markets: TENANT[]
  message?: string
  middlewarePartnerName: string
  name: string
  phoneNumber: string
  postalCode: string
  productsCount: number
  retailMediaMarketing: boolean
  revenueExpected: string
  revenueShare: number
  shopSystem: string
  streetName: string
  streetNumber: string
  targetCountries: string[]
  vatNumber: string
  website: string
}

export const initialData: MarketplacePartnerRegisterPageFormModel = {
  accountType: '',
  additionalAddress: '',
  annualRevenue: '',
  brands: [],
  brandsDropDown: [],
  brandsProviderType: BrandsProviderType.DROPDOWN,
  brandsTextArea: '',
  categories: [],
  city: '',
  companyType: [],
  country: '',
  countryCode: '',
  customerServiceInRespectiveLanguage: false,
  description: '',
  email: '',
  estimatedRevenue: 0,
  fcSolution: '',
  firstName: '',
  interestedInRetailMedia: false,
  keyBrand: '',
  lastName: '',
  marketReadiness: '',
  markets: [],
  message: '',
  middlewarePartnerName: '',
  name: '',
  phoneNumber: '',
  postalCode: '',
  productsCount: 0,
  retailMediaMarketing: false,
  revenueExpected: '',
  revenueShare: 0,
  shopSystem: '',
  streetName: '',
  streetNumber: '',
  targetCountries: [],
  vatNumber: '',
  website: '',
}

export const marketplacePartnerRegisterPageMakeFormState = ({
  intl,
  isSellerCentralFeatureEnabled,
}: {
  intl: IntlShape
  isSellerCentralFeatureEnabled: boolean
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types -- the rule was disabled before a comment became required
}) => {
  return makeFormStateWithModel({
    initialData,
    validations: makeMarketplacePartnerRegisterPageFormValidations({
      intl,
      isSellerCentralFeatureEnabled,
    }),
  })
}

export type MarketplacePartnerRegisterPageFormState = ReturnType<
  typeof marketplacePartnerRegisterPageMakeFormState
>
